var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgA1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_99_219)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2187 26.8004C10.9997 28.5432 9.57116 31.2479 9.57116 34.2859V37.1429H3.85705C2.27615 37.1429 1 35.8668 1 34.2859V32.3812C1 28.6956 3.98086 25.7147 7.66646 25.7147H9.57116C10.9235 25.7147 12.1711 26.1147 13.2187 26.8004Z",
    fill: "#2A323F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4755 25.7147C33.8424 25.7147 35.7611 23.796 35.7611 21.4291C35.7611 19.0623 33.8424 17.1436 31.4755 17.1436C29.1087 17.1436 27.1899 19.0623 27.1899 21.4291C27.1899 23.796 29.1087 25.7147 31.4755 25.7147Z",
    fill: "#2A323F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.61908 25.7147C10.9859 25.7147 12.9047 23.796 12.9047 21.4291C12.9047 19.0623 10.9859 17.1436 8.61908 17.1436C6.25222 17.1436 4.3335 19.0623 4.3335 21.4291C4.3335 23.796 6.25222 25.7147 8.61908 25.7147Z",
    fill: "#2A323F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0939 32.3812V34.2859C39.0939 35.8668 37.8178 37.1429 36.2369 37.1429H30.5228V34.2859C30.5228 31.2479 29.0942 28.5432 26.8752 26.8004C27.9228 26.1147 29.1704 25.7147 30.5228 25.7147H32.4275C36.1131 25.7147 39.0939 28.6956 39.0939 32.3812Z",
    fill: "#2A323F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0477 26.667C22.9406 26.667 25.2857 24.3219 25.2857 21.4291C25.2857 18.5363 22.9406 16.1912 20.0477 16.1912C17.1549 16.1912 14.8098 18.5363 14.8098 21.4291C14.8098 24.3219 17.1549 26.667 20.0477 26.667Z",
    fill: "#2A323F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9998 26.6671H19.0951C14.8943 26.6671 11.4763 30.0851 11.4763 34.2859V37.143C11.4763 38.7182 12.7582 40 14.3334 40H25.7616C27.3368 40 28.6186 38.7182 28.6186 37.143V34.2859C28.6186 30.0851 25.2007 26.6671 20.9998 26.6671Z",
    fill: "#2A323F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8567 13.0332L31.5587 13.8503C30.9063 14.0817 30.2254 13.5874 30.2445 12.8951L30.3111 10.4571L28.8236 8.52378C28.4017 7.97523 28.6617 7.1743 29.3254 6.97812L31.6654 6.28861L33.0444 4.27629C33.4358 3.70584 34.2777 3.70584 34.6691 4.27629L36.0481 6.28861L38.388 6.97812C39.0518 7.17335 39.3118 7.97523 38.8899 8.52378L37.4023 10.4571L37.469 12.8951C37.488 13.5865 36.8062 14.0817 36.1548 13.8503L33.8567 13.0332Z",
    fill: "#2A323F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.23808 13.0332L3.94005 13.8503C3.28769 14.0817 2.60676 13.5874 2.62581 12.8951L2.69247 10.4571L1.2049 8.52378C0.783009 7.97523 1.043 7.1743 1.70679 6.97812L4.04672 6.28861L5.42572 4.27629C5.81714 3.70584 6.65902 3.70584 7.05044 4.27629L8.42944 6.28861L10.7694 6.97812C11.4332 7.17335 11.6931 7.97523 11.2713 8.52378L9.78368 10.4571L9.85035 12.8951C9.8694 13.5865 9.18751 14.0817 8.5361 13.8503L6.23808 13.0332Z",
    fill: "#2A323F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.048 10.8904L17.3234 11.8589C16.5501 12.1342 15.7425 11.5465 15.7653 10.7266L15.8444 7.83619L14.0806 5.54388C13.5806 4.89342 13.8892 3.94393 14.6758 3.71155L17.45 2.89348L19.0852 0.507842C19.549 -0.16928 20.548 -0.16928 21.0118 0.507842L22.647 2.89348L25.4212 3.71155C26.2079 3.94393 26.5164 4.89342 26.0164 5.54388L24.2527 7.83619L24.3317 10.7266C24.3546 11.5465 23.546 12.1342 22.7737 11.8589L20.048 10.8904Z",
    fill: "#2A323F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_99_219"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgA1);
export default __webpack_public_path__ + "static/media/a1.081640fc5091f894be42ab7b514a5c1f.svg";
export { ForwardRef as ReactComponent };